import { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { IoIosArrowDown, IoMdLogOut } from "react-icons/io";
import {
  Avatar,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";

import pages from "../../constants/pages";
import Logo from "../../assets/growth_os.png";
import User from "../../assets/users.svg";
import { colors } from "../../pages/css components/Style";
import { PrimaryLoadingButton } from "../../pages/css components/Button";
import {
  setActiveBrand,
  signInMember,
  signOutMember,
} from "../../redux/slices/memberSlice";
import ENV from "../../config/config";
import { titleCase } from "change-case-all";

const Wrapper = styled.div`
  position: sticky;
  top: 0;
  min-height: 60px;
  border-radius: 0px;
  background: ${colors.theme};
  padding: 10px 10px 10px 10px;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 5px 5px -5px rgba(35, 37, 38, 0.15);
`;

const BrandDiv = styled.div`
  display: flex;
`;

const ImageDiv = styled.div`
  width: 50px;
  height: 40px;
  display: flex;
  margin-left: 10px;
`;

export default function Navbar({ toggleSideBar }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { dashboardPermissions } = useSelector((state) => state.memberDetails);
  const authToken =
    useSelector((state) => state?.memberDetails.authToken) ||
    sessionStorage.getItem("authToken");

  const parentState =
    useSelector((state) => state?.memberDetails.parentState) ||
    sessionStorage.getItem("ps");

  const userID = sessionStorage.getItem("userID");
  const businessEntityID = sessionStorage.getItem("businessEntityId");
  const reduxAgencyVerified = useSelector(
    (state) => state.memberDetails?.agency?.isAgencyVerified
  );

  const { agency } = useSelector((state) => state.memberDetails);

  const isAgencyVerified = state?.is_agency_verified
    ? state?.is_agency_verified
    : reduxAgencyVerified ?? sessionStorage.getItem("is_agency_verified");

  const agencyName = state?.agencyName ? state?.agencyName : agency?.agencyName;
  const agencyLogo = state?.agencyLogo ? state?.agencyLogo : agency?.agencyLogo;

  useEffect(() => {
    if (parentState === "AM") {
      sessionStorage.setItem("is_agency_verified", isAgencyVerified);
    }
  }, [isAgencyVerified]);

  return (
    <Wrapper>
      <div style={{ display: "flex", alignItems: "center" }}>
        <ImageDiv
          onClick={() => {
            const isAdminBrand = dashboardPermissions.some(
              (page) => page.ID === "administrator-brands"
            );

            const path = isAdminBrand
              ? pages.accountVerification.route
              : pages.brandDetails.route;

            navigate(path);
          }}
        >
          <img src={Logo} alt="!" />
        </ImageDiv>

        <Divider
          orientation="vertical"
          flexItem
          style={{ margin: "0 15px", height: "50px" }}
        />

        <div style={{ display: "flex" }}>
          <img
            src={User}
            alt="user"
            style={{ height: "12px", position: "relative", top: "6px" }}
          />
          <Typography style={{ fontWeight: 700, fontSize: "15px" }}>
            {" "}
            &nbsp; Audience
          </Typography>
          <IoIosArrowDown
            style={{
              fontSize: "14px",
              marginLeft: "6px",
              position: "relative",
              top: "6px",
            }}
          />
        </div>

        <Divider
          orientation="vertical"
          flexItem
          style={{ margin: "0 15px", height: "50px" }}
        />

        {location.pathname !== "/agency-switch" && parentState === "AM" && (
          <div
            className="change-agency-div"
            onClick={() => navigate(pages.intermediatePage.route)}
          >
            <Avatar
              style={{
                height: "25px",
                width: "25px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              src={agencyLogo}
            />{" "}
            <Typography>
              <Typography sx={{ fontSize: "11px" }}>Active Agency</Typography>
              <Typography sx={{ color: colors.publicisBlue, fontWeight: 600 }}>
                {agencyName && titleCase(agencyName)}
              </Typography>
            </Typography>
            <div className="change">Change</div>
          </div>
        )}
      </div>

      <BrandDiv>
        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
          {location.pathname !== "/agency-switch" &&
            parseInt(isAgencyVerified) === 1 && (
              <PrimaryLoadingButton
                loading={loading}
                style={{ float: "left" }}
                variant="contained"
                onClick={() => addNewBrand()}
              >
                Add New Brand
              </PrimaryLoadingButton>
            )}

          <Divider
            orientation="vertical"
            flexItem
            style={{ height: "50px", margin: "0 10px" }}
          />
          <Tooltip title="Logout">
            <IconButton
              style={{ border: `1px solid #5a5a5a` }}
              onClick={() => {
                dispatch(signOutMember());
                if (ENV === "dev") {
                  window.location = "https://buz.igrowthos.ai/";
                }

                if (ENV === "main") {
                  window.location = "https://www.growthosin.ai";
                }
              }}
            >
              <IoMdLogOut color={"#5a5a5a"} />
            </IconButton>
          </Tooltip>
        </div>
      </BrandDiv>
    </Wrapper>
  );

  async function addNewBrand() {
    setLoading(true);
    sessionStorage.setItem("role", "AGENCY");
    sessionStorage.setItem("is_agency_verified", isAgencyVerified);
    await dispatch(
      signInMember({
        authToken: authToken,
        userID: userID,
        businessEntityId: businessEntityID,
      })
    );
    dispatch(
      setActiveBrand({
        ID: "",
        about: "",
        brandName: "",
        logo: "",
        languages: [],
        locations: [],
        category: [],
        mau: "",
        onlineStore: "",
        website: "",
        socialMedia: {},
        brandType: "",
      })
    );
    setLoading(false);
    navigate(pages.brandDetailCreateEmpty.route + "?newMultiBrand=" + true, {
      state: {
        is_agency_verified: isAgencyVerified,
        agencyName: agencyName,
        agencyLogo: agencyLogo,
      },
    });
  }
}
